<template>
  <div class="oauth-callback">
    <LoadingBounce></LoadingBounce>
  </div>
</template>

<script>
import { NEWCLASS_BASE_URL } from '@/config';

import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'iframe-callback',

  computed: {
    ...mapGetters({
      routeQuery: 'getRouteQuery',
      currentUserLanguage: 'currentUserLanguage',
    }),
  },

  methods: {
    ...mapActions([
      'setToken',
      'setDevice',
      'signIn',
      'fetchUserLicence',
      'fetchPremiumSchool',
      'fetchGrades',
      'fetchSubjects',
    ]),

    handlePostMessage(event) {
      let payload;
      try {
        payload = JSON.parse(event.data);
      } catch (error) {
        return;
      }
      if (event.origin === NEWCLASS_BASE_URL && payload.method === 'setToken') {
        const token = payload.data.token;
        const continueUrl = this.routeQuery.continue_url;

        this.setToken(token)
          .then(() => {
            this.$i18n.locale = this.currentUserLanguage;
            return true;
          })
          .then(() => {
            if (continueUrl) {
              this.$router.replace(window.decodeURIComponent(continueUrl));
            } else {
              this.$router.replace('/');
            }
            return Promise.resolve();
          });
      }
    },
  },

  created() {
    window.addEventListener('message', this.handlePostMessage);
  },

  beforeMount() {
    const message = JSON.stringify({
      method: 'authorize',
      callback: 'setToken',
    });
    window.parent.postMessage(message, NEWCLASS_BASE_URL);
  },

  beforeDestroy() {
    window.removeEventListener('message', this.handlePostMessage);
  },
};
</script>
